/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onChatAssistantResponse = /* GraphQL */ `
  subscription OnChatAssistantResponse($id: String!) {
    onChatAssistantResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onPropertiesResponse = /* GraphQL */ `
  subscription OnPropertiesResponse($id: String!) {
    onPropertiesResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onFileUploadedResponse = /* GraphQL */ `
  subscription OnFileUploadedResponse($id: String!) {
    onFileUploadedResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onParcelSearchReturn = /* GraphQL */ `
  subscription OnParcelSearchReturn($id: String!) {
    onParcelSearchReturn(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onEmailReceived = /* GraphQL */ `
  subscription OnEmailReceived($id: String!) {
    onEmailReceived(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onZillowResponse = /* GraphQL */ `
  subscription OnZillowResponse($id: String!) {
    onZillowResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onSowAgentResponse = /* GraphQL */ `
  subscription OnSowAgentResponse($id: String!) {
    onSowAgentResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onQmaAutomationResponse = /* GraphQL */ `
  subscription OnQmaAutomationResponse($id: String!) {
    onQmaAutomationResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onCompsAgentResponse = /* GraphQL */ `
  subscription OnCompsAgentResponse($id: String!) {
    onCompsAgentResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onExitStrategyResponse = /* GraphQL */ `
  subscription OnExitStrategyResponse($id: String!) {
    onExitStrategyResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onExitStrategyChatResponse = /* GraphQL */ `
  subscription OnExitStrategyChatResponse($id: String!) {
    onExitStrategyChatResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const onPropertyRemovalResponse = /* GraphQL */ `
  subscription OnPropertyRemovalResponse($id: String!) {
    onPropertyRemovalResponse(id: $id) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
